<form (ngSubmit)="save()" [formGroup]="form">
  <div class="flex items-center justify-between" mat-dialog-title>
    <div>
      @if (isUpdateMode() && canEdit()) {
      <h4 class="text-sm font-light">Editace autora</h4>
      } @if (isUpdateMode() && !canEdit()) {
      <h4 class="text-sm font-light">Náhled autora</h4>
      } @if (form.get('nickname').value && isUpdateMode()) {
      <h2 class="flex-auto m-0 headline">
        {{ form.get("nickname").value }}
      </h2>
      } @if ( (form.get('firstname').value || form.get('lastname').value ||
      form.get('nickname').value) && isUpdateMode() &&
      !form.get('nickname').value ) {
      <h2 class="flex-auto m-0 headline">
        {{ form.get("firstname").value + " " + form.get("lastname").value }}
      </h2>
      } @if (isCreateMode()) {
      <h2 class="flex-auto m-0 headline">Nový autor</h2>
      }
    </div>

    <button
      class="text-secondary"
      mat-dialog-close
      mat-icon-button
      type="button"
    >
      <mat-icon svgIcon="mat:close"></mat-icon>
    </button>
  </div>

  <mat-divider class="text-border"></mat-divider>

  <mat-dialog-content class="flex flex-col">
    @if (form.get('canvasId').value) {
    <mat-form-field>
      <mat-label>Canvas ID</mat-label>
      <input formControlName="canvasId" matInput [disabled]="true" />
      <mat-icon matPrefix svgIcon="mat:fingerprint"></mat-icon>
    </mat-form-field>
    }

    <div class="flex flex-col sm:flex-row">
      <mat-form-field class="flex-auto">
        <mat-label>Jméno</mat-label>
        <input formControlName="firstname" matInput />
      </mat-form-field>

      <mat-form-field class="flex-auto sm:ml-6">
        <mat-label>Příjmení</mat-label>
        <input formControlName="lastname" matInput />
      </mat-form-field>
    </div>

    <mat-form-field>
      <mat-label>Zobrazované jméno</mat-label>
      <input cdkFocusInitial formControlName="nickname" matInput />
      <mat-icon matPrefix svgIcon="mat:perm_identity"></mat-icon>
    </mat-form-field>

    <div class="flex flex-col sm:flex-row">
      <mat-form-field class="flex-auto">
        <mat-label>Narození</mat-label>
        <input formControlName="birthday" matInput />
      </mat-form-field>

      <mat-form-field class="flex-auto sm:ml-6">
        <mat-label>Úmrtí</mat-label>
        <input formControlName="death" matInput />
      </mat-form-field>
    </div>

    @if (isEditorContext()) {
    <div class="flex flex-col mb-2">
      <div class="flex items-center -mb-0.5 ml-2">
        <mat-icon class="mr-2" matPrefix svgIcon="mat:notes"></mat-icon>
        <h2 class="font-semibold">Popis</h2>
      </div>
      <div>
        <editor
          [init]="tinyService.modulesEasy()"
          class="w-full"
          formControlName="descriptionCS"
        >
        </editor>
      </div>
    </div>
    } @if (isEditorContext()) {
    <div class="flex flex-col mb-2">
      <div class="flex items-center -mb-0.5 ml-2">
        <mat-icon class="mr-2" matPrefix svgIcon="mat:notes"></mat-icon>
        <h2 class="font-semibold">Description</h2>
      </div>
      <div>
        <editor
          [init]="tinyService.modulesEasy()"
          class="w-full"
          formControlName="descriptionEN"
        >
        </editor>
      </div>
    </div>
    } @if (isEditorContext()) {
    <div class="flex justify-between w-full mb-4">
      <div class="flex items-center space-x-2">
        <mat-label class="font-semibold">Globální</mat-label
        ><mat-icon
          svgIcon="mat:info"
          matTooltip="Určuje, zda je autor viditelný ve všech soupisech"
        ></mat-icon>
      </div>
      <mat-slide-toggle formControlName="curated"> </mat-slide-toggle>
    </div>
    }
  </mat-dialog-content>

  @if (canEdit()) {
  <mat-divider class="text-border"></mat-divider>
  } @if (canEdit()) {
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">Zrušit</button>
    <button
      color="primary"
      mat-flat-button
      type="submit"
      [disabled]="form.invalid"
    >
      {{ isCreateMode() ? "Vytvořit" : "Aktualizovat" }}
    </button>
  </mat-dialog-actions>
  }
</form>
